import { useState } from 'react';

import Cookies from 'js-cookie';

import { useNavigation } from '@/modules/utils/custom-hooks/use-navigation';

interface CookieSettings {
  event: 'cookieSettings';
  cookieAnalytics: boolean;
  cookiePreferences: boolean;
}

export const useCookieSettings = () => {
  const { removeAllSearchParams } = useNavigation();
  const [analyticsConsent, setAnalyticsConcent] = useState<boolean>(localStorage.getItem('analyticsConsent') === 'true');
  const [preferencesConcent, setPreferencesConcent] = useState<boolean>(localStorage.getItem('preferencesConcent') === 'true');
  const noneSelected = !analyticsConsent && !preferencesConcent;
  const locale = Cookies.get('NEXT_LOCALE');

  const pushToDataLayer = ({ cookieAnalytics, cookiePreferences }: Omit<CookieSettings, 'event'>) => {
    window.dataLayer = window.dataLayer || [];
    if (Array.isArray(window.dataLayer)) {
      const index = window.dataLayer.findIndex((item) => (item as CookieSettings).event === 'cookieSettings');

      if (index !== -1) {
        window.dataLayer[index] = {
          event: 'cookieSettings',
          cookieAnalytics,
          cookiePreferences
        };
      } else {
        window.dataLayer.push({
          event: 'cookieSettings',
          cookieAnalytics,
          cookiePreferences
        } satisfies CookieSettings);
      }
    }
  };

  const handleSelectedButton = () => {
    localStorage.setItem('analyticsConsent', analyticsConsent.toString());
    localStorage.setItem('preferencesConcent', preferencesConcent.toString());
    pushToDataLayer({ cookieAnalytics: analyticsConsent, cookiePreferences: preferencesConcent });
    Cookies.set('hasSeenCookieModal', 'true', { expires: 365 });
    removeAllSearchParams();
  };

  const handleAllButton = (concent: boolean) => {
    setAnalyticsConcent(concent);
    setPreferencesConcent(concent);
    localStorage.setItem('analyticsConsent', concent.toString());
    localStorage.setItem('preferencesConcent', concent.toString());
    pushToDataLayer({ cookieAnalytics: concent, cookiePreferences: concent });
    Cookies.set('hasSeenCookieModal', 'true', { expires: 365 });
    setTimeout(() => removeAllSearchParams(), 300);
  };

  return {
    analyticsConsent,
    preferencesConcent,
    noneSelected,
    locale,
    setAnalyticsConcent,
    setPreferencesConcent,
    handleSelectedButton,
    handleAllButton
  };
};
